<template lang="pug">
button-base.button-icon-circle(@click='clickEvent', :data-color='color')
  image-base.button-icon-circle__icon(:src='require(`@/assets/img/common/icon/${type}.svg`)')
  .button-icon-circle__description.font-medium(v-if='isExistSlot')
    slot
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'

/**
 * アイコン付きボタン
 */
@Component({
  components: {
    ButtonBase,
    ImageBase,
  },
})
export default class ButtonIconCircle extends Vue {
  /**
   * ボタン種別
   * + NOTE: 使用するアイコンファイル名【 assets/img/common/icon/${type}.svg 】と一致させる
   */
  @Prop()
  type!: 'remove' | 'download' | 'upload' | 'edit' | 'qr'

  /** ボタン色 */
  @Prop({ default: 'default' })
  color!: 'default' | 'red'

  /**
   * Slot存在判定
   * + NOTE: Slot内容を:hover時の説明ポップアップとして表示する
   */
  private get isExistSlot(): boolean {
    return !!this.$scopedSlots.default
  }

  /** クリック時イベント */
  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.button-icon-circle
  display flex
  align-items center
  justify-content center
  border-radius 50%
  width 30px
  height 30px

  &__icon
    display flex
    align-items center
    justify-content center
    width 20px
    height 20px

  &[data-color='default']
    background-color var(--color-input-manager-icon-circle__background-default)
  &[data-color='red']
    background-color var(--color-input-manager-icon-circle__background-red)

  &__description
    pointer-events none
    position absolute
    top -45px
    border-radius 12px
    padding 10px
    font-size 14px
    word-break keep-all
    color var(--color-input-manager-icon-circle__description-text)
    background-color var(--color-input-manager-icon-circle__description-background)
    opacity 0
    ~/:hover &
      opacity 1
</style>
